var IconTypes;
(function (IconTypes) {
    IconTypes["APPLE_PAY_24"] = "apple-pay-24";
    IconTypes["APPLE_PAY_36"] = "apple-pay-36";
    IconTypes["APPLE_PAY_DYN"] = "apple-pay";
    /** @deprecated ATTACHMENT_24 */
    IconTypes["ATTACHMENT_24"] = "attachment-24";
    /** @deprecated ATTACHMENT_36 */
    IconTypes["ATTACHMENT_36"] = "attachment-36";
    IconTypes["ATV_24"] = "atv-24";
    IconTypes["ATV_36"] = "atv-36";
    IconTypes["BANK_24"] = "bank-24";
    IconTypes["BANK_36"] = "bank-36";
    IconTypes["BANK_ID_BRIKKE_24"] = "bank-id-brikke-24";
    IconTypes["BANK_ID_BRIKKE_36"] = "bank-id-brikke-36";
    IconTypes["BANK_ID_PA_MOBIL_24"] = "bank-id-pa-mobil-24";
    IconTypes["BANK_ID_PA_MOBIL_36"] = "bank-id-pa-mobil-36";
    IconTypes["BANKKORT_24"] = "bankkort-24";
    IconTypes["BANKKORT_36"] = "bankkort-36";
    IconTypes["BARN_24"] = "barn-24";
    IconTypes["BARN_36"] = "barn-36";
    IconTypes["BAT_24"] = "bat-24";
    IconTypes["BAT_36"] = "bat-36";
    IconTypes["BEDRIFT_24"] = "bedrift-24";
    IconTypes["BEDRIFT_36"] = "bedrift-36";
    IconTypes["BETALE_24"] = "betale-24";
    IconTypes["BETALE_36"] = "betale-36";
    IconTypes["BEVEGELSER_24"] = "bevegelser-24";
    IconTypes["BEVEGELSER_36"] = "bevegelser-36";
    IconTypes["BIL_24"] = "bil-24";
    IconTypes["BIL_36"] = "bil-36";
    IconTypes["BIL_2_24"] = "bil-2-24";
    IconTypes["BIL_2_36"] = "bil-2-36";
    IconTypes["BIL_2_DYN"] = "bil-2";
    IconTypes["BIOMETRI_24"] = "biometri-24";
    IconTypes["BIOMETRI_36"] = "biometri-36";
    IconTypes["BIOMETRI_DYN"] = "biometri";
    IconTypes["BLAD_24"] = "blad-24";
    IconTypes["BLAD_36"] = "blad-36";
    IconTypes["BOBIL_24"] = "bobil-24";
    IconTypes["BOBIL_36"] = "bobil-36";
    IconTypes["BONDEGARD_24"] = "bondegard-24";
    IconTypes["BONDEGARD_36"] = "bondegard-36";
    /** @deprecated BUET_PIL_HOEYRE_20 */
    IconTypes["BUET_PIL_HOEYRE_20"] = "buet-pil-hoeyre-20";
    IconTypes["BUTIKK_24"] = "butikk-24";
    IconTypes["BUTIKK_36"] = "butikk-36";
    IconTypes["BYGGELAN_24"] = "byggelan-24";
    IconTypes["BYGGELAN_36"] = "byggelan-36";
    IconTypes["CAMPING_24"] = "camping-24";
    IconTypes["CAMPING_36"] = "camping-36";
    IconTypes["CHAT_24"] = "chat-24";
    IconTypes["CHAT_36"] = "chat-36";
    /** @deprecated CHECKED_24 */
    IconTypes["CHECKED_24"] = "checked-24";
    IconTypes["CHECKMARK_LISTE_24"] = "checkmark-liste-24";
    IconTypes["CHECKMARK_TIL_BOKS_24"] = "checkmark-til-boks-24";
    IconTypes["CHECKMARK_TIL_SIRKEL_24"] = "checkmark-til-sirkel-24";
    IconTypes["CHECKMARK_TIL_SIRKEL_36"] = "checkmark-til-sirkel-36";
    IconTypes["COPY_24"] = "copy-24";
    IconTypes["COPY_36"] = "copy-36";
    IconTypes["DODSFALL_24"] = "dodsfall-24";
    IconTypes["DODSFALL_36"] = "dodsfall-36";
    IconTypes["DOKUMENT_24"] = "dokument-24";
    IconTypes["DOKUMENT_36"] = "dokument-36";
    IconTypes["DRAG_N_DROP_24"] = "drag-n-drop-24";
    IconTypes["DRONE_24"] = "drone-24";
    IconTypes["DRONE_36"] = "drone-36";
    IconTypes["DRONE_DYN"] = "drone";
    IconTypes["E_FAKTURA_24"] = "e-faktura-24";
    /** @deprecated use E_FAKTURA_24 */
    IconTypes["E_FAKTURA_24_1"] = "e-faktura-24_1";
    IconTypes["E_FAKTURA_36"] = "e-faktura-36";
    IconTypes["E_FAKTURA_LOGO_24"] = "e-faktura-logo-24";
    IconTypes["E_FAKTURA_LOGO_36"] = "e-faktura-logo-36";
    IconTypes["EKSTERN_24"] = "ekstern-24";
    /** @deprecated EKSTERN_36 */
    IconTypes["EKSTERN_36"] = "ekstern-36";
    IconTypes["ELSPAREKSYKKEL_24"] = "elsparkesykkel-24";
    IconTypes["ELSPAREKSYKKEL_36"] = "elsparkesykkel-36";
    IconTypes["ELSPARKESYKKEL_DYN"] = "elsparkesykkel";
    /** @deprecated use faste-betalinger-36 */
    IconTypes["FAST_BETALING_36"] = "fast-betaling-36";
    /** @deprecated FAST_OVERFOR_36 */
    IconTypes["FAST_OVERFOR_36"] = "fast-overfor-36";
    IconTypes["FAKTURA_24"] = "faktura-24";
    IconTypes["FAKTURA_36"] = "faktura-36";
    IconTypes["FAMILIE_24"] = "familie-24";
    IconTypes["FAMILIE_36"] = "familie-36";
    IconTypes["FASTE_BETALINGER_24"] = "faste-betalinger-24";
    IconTypes["FASTE_BETALINGER_36"] = "faste-betalinger-36";
    IconTypes["FASTE_BETALINGER_DYN"] = "faste-betalinger";
    IconTypes["FORDELER_24"] = "fordeler-24";
    IconTypes["FORDELER_36"] = "fordeler-36";
    IconTypes["FORSIKRINGSBEVIS_REISE_24"] = "forsikringsbevis-reise-24";
    IconTypes["FORSIKRINGSBEVIS_REISE_36"] = "forsikringsbevis-reise-36";
    IconTypes["GAVE_24"] = "gave-24";
    IconTypes["GAVE_36"] = "gave-36";
    IconTypes["GOOGLE_PAY_24"] = "google-pay-24";
    IconTypes["GOOGLE_PAY_36"] = "google-pay-36";
    IconTypes["GOOGLE_PAY_DYN"] = "google-pay";
    IconTypes["GRAFLINJE_24"] = "graflinje-24";
    IconTypes["GRAFLINJE_36"] = "graflinje-36";
    IconTypes["GRAVEMASKIN_24"] = "gravemaskin-24";
    IconTypes["GRAVEMASKIN_36"] = "gravemaskin-36";
    IconTypes["GRUPPE_24"] = "gruppe-24";
    IconTypes["GRUPPE_36"] = "gruppe-36";
    IconTypes["HAMBURGER"] = "hamburger";
    IconTypes["HANDLEKURV_24"] = "handlekurv-24";
    IconTypes["HANDLEKURV_36"] = "handlekurv-36";
    IconTypes["HANDTRYKK_24"] = "handtrykk-24";
    IconTypes["HANDTRYKK_36"] = "handtrykk-36";
    IconTypes["HANDTVERKER__BIL_36"] = "handtverker--bil-36";
    // @deprecate use HANDTVERKER__BIL_36 instead
    IconTypes["HANDTVERKER__BIL_36_2"] = "handtverker--bil-36_2";
    IconTypes["HANDTVERKER_BIL_24"] = "handtverker-bil-24";
    IconTypes["HANDVERKER_24"] = "handverker-24";
    IconTypes["HANDVERKER_36"] = "handverker-36";
    IconTypes["HELSE_24"] = "helse-24";
    IconTypes["HELSE_36"] = "helse-36";
    IconTypes["HENGELAS_APEN_24"] = "hengelas-apen-24";
    IconTypes["HENGELAS_APEN_36"] = "hengelas-apen-36";
    IconTypes["HEST_24"] = "hest-24";
    IconTypes["HEST_36"] = "hest-36";
    IconTypes["HONE_24"] = "hone-24";
    IconTypes["HONE_36"] = "hone-36";
    IconTypes["HUND_24"] = "hund-24";
    IconTypes["HUND_36"] = "hund-36";
    IconTypes["HUS_24"] = "hus-24";
    IconTypes["HUS_36"] = "hus-36";
    IconTypes["HYTTE_24"] = "hytte-24";
    IconTypes["HYTTE_36"] = "hytte-36";
    IconTypes["INBOX_24"] = "inbox-24";
    IconTypes["INBOX_36"] = "inbox-36";
    IconTypes["INFO_20"] = "info-20";
    IconTypes["INFO_24"] = "info-24";
    IconTypes["INFO_36"] = "info-36";
    IconTypes["INNBOFORSIKRING_24"] = "innboforsikring-24";
    IconTypes["INNBOFORSIKRING_36"] = "innboforsikring-36";
    IconTypes["INNFRI_KREDITTKORT_24"] = "innfri-kredittkort-24";
    IconTypes["INNFRI_KREDITTKORT_36"] = "innfri-kredittkort-36";
    IconTypes["INNSTILLINGER_24"] = "innstillinger-24";
    IconTypes["INNSTILLINGER_36"] = "innstillinger-36";
    IconTypes["INNTEKT_24"] = "inntekt-24";
    IconTypes["INNTEKT_36"] = "inntekt-36";
    IconTypes["JORDEN_24"] = "jorden-24";
    IconTypes["JORDEN_36"] = "jorden-36";
    IconTypes["KAKEDIAGRAM_24"] = "kakediagram-24";
    IconTypes["KAKEDIAGRAM_36"] = "kakediagram-36";
    IconTypes["KALENDER_20"] = "kalender-20";
    IconTypes["KALENDER_24"] = "kalender-24";
    IconTypes["KALENDER_36"] = "kalender-36";
    IconTypes["KALKULATOR_24"] = "kalkulator-24";
    IconTypes["KALKULATOR_36"] = "kalkulator-36";
    IconTypes["KAMERA_24"] = "kamera-24";
    IconTypes["KAMERA_36"] = "kamera-36";
    IconTypes["KART_24"] = "kart-24";
    IconTypes["KART_36"] = "kart-36";
    IconTypes["KATT_24"] = "katt-24";
    IconTypes["KATT_36"] = "katt-36";
    IconTypes["KATT_DYN"] = "katt";
    IconTypes["KJORETOY_24"] = "kjoretoy-24";
    IconTypes["KJORETOY_36"] = "kjoretoy-36";
    IconTypes["KLOKKE_24"] = "klokke-24";
    IconTypes["KLOKKE_36"] = "klokke-36";
    IconTypes["KONTOER_24"] = "kontoer-24";
    IconTypes["KONTOER_36"] = "kontoer-36";
    IconTypes["KONTOR_24"] = "kontor-24";
    IconTypes["KONTOR_36"] = "kontor-36";
    IconTypes["KREDITTGRENSE_24"] = "kredittgrense-24";
    IconTypes["KREDITTGRENSE_36"] = "kredittgrense-36";
    IconTypes["KRYSS_24"] = "kryss-24";
    IconTypes["KRYSS_36"] = "kryss-36";
    IconTypes["KU_24"] = "ku-24";
    IconTypes["KU_36"] = "ku-36";
    IconTypes["LAN_24"] = "lan-24";
    IconTypes["LAN_36"] = "lan-36";
    IconTypes["LASTEBIL_24"] = "lastebil-24";
    IconTypes["LASTEBIL_36"] = "lastebil-36";
    IconTypes["LEGE_24"] = "lege-24";
    IconTypes["LEGE_36"] = "lege-36";
    IconTypes["LITEN_PIL_HOEYRE"] = "liten-pil-hoeyre";
    /** @deprecated LITEN_PIL_HOEYRE_1 */
    IconTypes["LITEN_PIL_HOEYRE_1"] = "liten-pil-hoeyre_1";
    IconTypes["LITEN_PIL_NED"] = "liten-pil-ned";
    IconTypes["LITEN_PIL_OPP"] = "liten-pil-opp";
    IconTypes["LITEN_PIL_VENSTRE"] = "liten-pil-venstre";
    IconTypes["LOMMEBOK_24"] = "lommebok-24";
    IconTypes["LOMMEBOK_36"] = "lommebok-36";
    IconTypes["LUKK_24"] = "lukk-24";
    IconTypes["LYSPAERE_24"] = "lyspaere-24";
    IconTypes["LYSPAERE_36"] = "lyspaere-36";
    IconTypes["MAIL_24"] = "mail-24";
    IconTypes["MAIL_36"] = "mail-36";
    IconTypes["MASTERCARD_24"] = "mastercard-24";
    IconTypes["MASTERCARD_36"] = "mastercard-36";
    IconTypes["MEDALJE_24"] = "medalje-24";
    IconTypes["MEDALJE_36"] = "medalje-36";
    IconTypes["MENY_24"] = "meny-24";
    IconTypes["MENY_36"] = "meny-36";
    IconTypes["MER_24"] = "mer-24";
    IconTypes["MER_36"] = "mer-36";
    IconTypes["MINIMER_24"] = "minimer-24";
    IconTypes["MINUS_24"] = "minus-24";
    IconTypes["MINUS_36"] = "minus-36";
    IconTypes["MOBIL_24"] = "mobil-24";
    IconTypes["MOBIL_36"] = "mobil-36";
    IconTypes["MOBILBANK_24"] = "mobilbank-24";
    IconTypes["MOBILBANK_36"] = "mobilbank-36";
    IconTypes["MOPED_24"] = "moped-24";
    IconTypes["MOPED_36"] = "moped-36";
    IconTypes["MOTORSYKKEL_24"] = "motorsykkel-24";
    IconTypes["MOTORSYKKEL_36"] = "motorsykkel-36";
    IconTypes["NEDLASTING_24"] = "nedlasting-24";
    IconTypes["NEDLASTING_36"] = "nedlasting-36";
    IconTypes["NETTBANK_24"] = "nettbank-24";
    IconTypes["NETTBANK_36"] = "nettbank-36";
    IconTypes["NOKKEL_24"] = "nokkel-24";
    IconTypes["NOKKEL_36"] = "nokkel-36";
    IconTypes["NYHETER_24"] = "nyheter-24";
    IconTypes["NYHETER_36"] = "nyheter-36";
    IconTypes["OVERFOERE_24"] = "overfoere-24";
    IconTypes["OVERFOERE_36"] = "overfoere-36";
    IconTypes["OYE_24"] = "oye-24";
    IconTypes["OYE_36"] = "oye-36";
    IconTypes["PALME_24"] = "palme-24";
    IconTypes["PALME_36"] = "palme-36";
    IconTypes["PALME_DYN"] = "palme";
    IconTypes["PARAPLY_24"] = "paraply-24";
    IconTypes["PARAPLY_36"] = "paraply-36";
    IconTypes["PENGESEKK_24"] = "pengesekk-24";
    IconTypes["PENGESEKK_36"] = "pengesekk-36";
    IconTypes["PENN_24"] = "penn-24";
    IconTypes["PENN_36"] = "penn-36";
    // @deprecated use palme-36
    IconTypes["PENSJON_36"] = "pensjon-36";
    IconTypes["PERSONER_24"] = "personer-24";
    IconTypes["PERSONER_36"] = "personer-36";
    IconTypes["PIL_DROPDOWN_OPP_24"] = "pil-dropdown-opp-24";
    IconTypes["PIL_DROPDOWN_NED_24"] = "pil-dropdown-ned-24";
    IconTypes["PIL_HOEYRE"] = "pil-hoeyre";
    IconTypes["PIL_NED"] = "pil-ned";
    IconTypes["PIL_OPP"] = "pil-opp";
    IconTypes["PIL_VENSTRE"] = "pil-venstre";
    IconTypes["PIL_STOR_HOEYRE_24"] = "pil-stor-hoeyre-24";
    IconTypes["PIL_STOR_NED_24"] = "pil-stor-ned-24";
    IconTypes["PIL_STOR_OPP_24"] = "pil-stor-opp-24";
    IconTypes["PIL_STOR_VENSTRE_24"] = "pil-stor-venstre-24";
    IconTypes["PIN_KODE_24"] = "pin-kode-24";
    IconTypes["PIN_KODE_36"] = "pin-kode-36";
    IconTypes["PLANTE_24"] = "plante-24";
    IconTypes["PLANTE_36"] = "plante-36";
    IconTypes["PLASTER_24"] = "plaster-24";
    IconTypes["PLASTER_36"] = "plaster-36";
    IconTypes["PLUSS_24"] = "pluss-24";
    IconTypes["PLUSS_36"] = "pluss-36";
    IconTypes["PRINT_24"] = "print-24";
    IconTypes["PRINT_36"] = "print-36";
    IconTypes["PRIS_PIL_36"] = "pris-pil-36";
    IconTypes["PROFIL_24"] = "profil-24";
    IconTypes["PROFIL_36"] = "profil-36";
    IconTypes["PROFIL_I_SIRKEL_24"] = "profil-i-sirkel-24";
    IconTypes["RADGIVER_24"] = "radgiver-24";
    IconTypes["RADGIVER_36"] = "radgiver-36";
    IconTypes["RADGIVING_24"] = "radgiving-24";
    IconTypes["RADGIVING_36"] = "radgiving-36";
    IconTypes["REFINANSIERING_24"] = "refinansiering-24";
    IconTypes["REFINANSIERING_36"] = "refinansiering-36";
    IconTypes["REGIONSPERRE_24"] = "regionsperre-24";
    IconTypes["REGIONSPERRE_36"] = "regionsperre-36";
    IconTypes["RENTER_24"] = "renter-24";
    IconTypes["RENTER_36"] = "renter-36";
    IconTypes["RESIRKULER_24"] = "resirkuler-24";
    IconTypes["RESIRKULER_36"] = "resirkuler-36";
    IconTypes["SAMSUNG_WALLET_24"] = "samsung-wallet-24";
    IconTypes["SAMSUNG_WALLET_36"] = "samsung-wallet-36";
    IconTypes["SAMSUNG_WALLET_DYN"] = "samsung-wallet";
    IconTypes["SIGNATUR_24"] = "signatur-24";
    IconTypes["SIGNATUR_36"] = "signatur-36";
    IconTypes["SIKKERHET_24"] = "sikkerhet-24";
    IconTypes["SIKKERHET_36"] = "sikkerhet-36";
    IconTypes["SKADE_24"] = "skade-24";
    IconTypes["SKADE_36"] = "skade-36";
    IconTypes["SLETT_24"] = "slett-24";
    IconTypes["SLETT_36"] = "slett-36";
    IconTypes["SNAPCASH_24"] = "snapcash-24";
    IconTypes["SNAPCASH_36"] = "snapcash-36";
    IconTypes["SNOSCOOTER_24"] = "snoscooter-24";
    IconTypes["SNOSCOOTER_36"] = "snoscooter-36";
    IconTypes["SOEK_24"] = "soek-24";
    IconTypes["SOEK_36"] = "soek-36";
    IconTypes["SPAREGRIS_24"] = "sparegris-24";
    IconTypes["SPAREGRIS_36"] = "sparegris-36";
    IconTypes["SPARING_24"] = "sparing-24";
    IconTypes["SPARING_36"] = "sparing-36";
    IconTypes["SPERR_KORT_24"] = "sperr-kort-24";
    IconTypes["SPERR_KORT_36"] = "sperr-kort-36";
    // @deprecated use SPOERSMAALSTEGN_24
    IconTypes["SPOERSMAAL_24"] = "spoersmaal-24";
    IconTypes["SPOERSMAALSTEGN_24"] = "spoersmaalstegn-24";
    IconTypes["SPOERSMAALSTEGN_36"] = "spoersmaalstegn-36";
    IconTypes["SPOERSMAALSTEGN_DYN"] = "spoersmaalstegn";
    IconTypes["STJERNE_24"] = "stjerne-24";
    IconTypes["STJERNE_36"] = "stjerne-36";
    IconTypes["STJERNEDRYSS_24"] = "stjernedryss-24";
    IconTypes["STJERNEDRYSS_36"] = "stjernedryss-36";
    IconTypes["STJERNEDRYSS_DYN"] = "stjernedryss";
    IconTypes["STOPP_24"] = "stopp-24";
    IconTypes["STOPP_36"] = "stopp-36";
    IconTypes["TANNHJUL_24"] = "tannhjul-24";
    IconTypes["TANNHJUL_36"] = "tannhjul-36";
    IconTypes["TAXI_24"] = "taxi-24";
    IconTypes["TAXI_36"] = "taxi-36";
    IconTypes["TELEFON_24"] = "telefon-24";
    IconTypes["TELEFON_36"] = "telefon-36";
    IconTypes["TILHENGER_24"] = "tilhenger-24";
    IconTypes["TILHENGER_36"] = "tilhenger-36";
    IconTypes["TIMEGLASS_24"] = "timeglass-24";
    IconTypes["TIMEGLASS_36"] = "timeglass-36";
    IconTypes["TOMMEL_OPP_24"] = "tommel-opp-24";
    IconTypes["TOMMEL_OPP_36"] = "tommel-opp-36";
    IconTypes["TOMMEL_OPP_DYN"] = "tommel-opp";
    IconTypes["TRAKTOR_24"] = "traktor-24";
    IconTypes["TRAKTOR_36"] = "traktor-36";
    IconTypes["TREKANT_KRYSS_24"] = "trekant-kryss-24";
    IconTypes["TREKANT_KRYSS_36"] = "trekant-kryss-36";
    IconTypes["UFOR_24"] = "ufor-24";
    IconTypes["UFOR_36"] = "ufor-36";
    IconTypes["ULYKKE_24"] = "ulykke-24";
    IconTypes["ULYKKE_36"] = "ulykke-36";
    /** @deprecated UNCHECKED_24 */
    IconTypes["UNCHECKED_24"] = "unchecked-24";
    IconTypes["UNG_24"] = "ung-24";
    IconTypes["UNG_36"] = "ung-36";
    IconTypes["USP_CHECKMARK_24"] = "usp-checkmark-24";
    IconTypes["USP_CHECKMARK_36"] = "usp-checkmark-36";
    IconTypes["UTROPSTEGN_24"] = "utropstegn-24";
    IconTypes["UTROPSTEGN_36"] = "utropstegn-36";
    IconTypes["VARETRANSPORT_24"] = "varetransport-24";
    IconTypes["VARETRANSPORT_36"] = "varetransport-36";
    IconTypes["VARSLER_24"] = "varsler-24";
    IconTypes["VARSLER_36"] = "varsler-36";
    IconTypes["VEKST_24"] = "vekst-24";
    IconTypes["VEKST_36"] = "vekst-36";
    /** @deprecated VEKT_24 */
    IconTypes["VEKT_24"] = "vekt-24";
    IconTypes["VEKT_24_2"] = "vekt-24_2";
    IconTypes["VEKT_36"] = "vekt-36";
    IconTypes["VERDI_24"] = "verdi-24";
    IconTypes["VERDI_36"] = "verdi-36";
    IconTypes["VETERANBIL_24"] = "veteranbil-24";
    /** @deprecated VETERANBIL_36 */
    IconTypes["VETERANBIL_36"] = "veteranbil-36";
    IconTypes["VIPPS_24"] = "vipps-24";
    IconTypes["VIPPS_36"] = "vipps-36";
    IconTypes["VIPPS_DYN"] = "vipps";
    IconTypes["BACK"] = "back";
    IconTypes["BANDAGED_HEART"] = "bandaged-heart";
    IconTypes["CALENDAR_20"] = "calendar-20";
    IconTypes["CALENDAR_24"] = "calendar-24";
    IconTypes["CALENDAR_36"] = "calendar-36";
    IconTypes["SPEECH_BUBBLE_HAPPY"] = "speech-bubble-happy";
    IconTypes["SPEECH_BUBBLE_SAD"] = "speech-bubble-sad";
    IconTypes["SPEECH_BUBBLE_TALKING"] = "speech-bubble-talking";
    IconTypes["WALLET_QUESTIONMARK"] = "wallet-questionmark";
    IconTypes["WAVING_HAND"] = "waving-hand";
    IconTypes["HEART"] = "heart";
    IconTypes["ExternalLink"] = "external-link";
    IconTypes["FRAMED_PROFILE_22"] = "framed-profile-22";
    IconTypes["FRAMED_PROFILE_24"] = "framed-profile-24";
    IconTypes["ATTACHMENT_DYN"] = "attachment";
    IconTypes["ATV_DYN"] = "atv";
    IconTypes["BANK_DYN"] = "bank";
    IconTypes["BANK_ID_BRIKKE_DYN"] = "bank-id-brikke";
    IconTypes["BANK_ID_PA_MOBIL_DYN"] = "bank-id-pa-mobil";
    IconTypes["BANKKORT_DYN"] = "bankkort";
    IconTypes["BARN_DYN"] = "barn";
    IconTypes["BAT_DYN"] = "bat";
    IconTypes["BEDRIFT_DYN"] = "bedrift";
    IconTypes["BETALE_DYN"] = "betale";
    IconTypes["BEVEGELSER_DYN"] = "bevegelser";
    IconTypes["BIL_DYN"] = "bil";
    IconTypes["BOBIL_DYN"] = "bobil";
    IconTypes["BONDEGARD_DYN"] = "bondegard";
    IconTypes["BUTIKK_DYN"] = "butikk";
    IconTypes["BYGGELAN_DYN"] = "byggelan";
    IconTypes["CALENDAR_DYN"] = "calendar";
    IconTypes["CAMPING_DYN"] = "camping";
    IconTypes["CHAT_DYN"] = "chat";
    IconTypes["CHECKMARK_TIL_SIRKEL_DYN"] = "checkmark-til-sirkel";
    IconTypes["COPY_DYN"] = "copy";
    IconTypes["DODSFALL_DYN"] = "dodsfall";
    IconTypes["DOKUMENT_DYN"] = "dokument";
    IconTypes["E_FAKTURA_DYN"] = "e-faktura";
    IconTypes["E_FAKTURA_LOGO_DYN"] = "e-faktura-logo";
    IconTypes["EKSTERN_DYN"] = "ekstern";
    IconTypes["FACEBOOK_24"] = "facebook-24";
    IconTypes["FACEBOOK_36"] = "facebook-36";
    IconTypes["FACEBOOK_DYN"] = "facebook";
    IconTypes["FAKTURA_DYN"] = "faktura";
    IconTypes["FAMILIE_DYN"] = "familie";
    IconTypes["FORDELER_DYN"] = "fordeler";
    IconTypes["FORSIKRINGSBEVIS_REISE_DYN"] = "forsikringsbevis-reise";
    IconTypes["GAVE_DYN"] = "gave";
    IconTypes["GRAFLINJE_DYN"] = "graflinje";
    IconTypes["GRAVEMASKIN_DYN"] = "gravemaskin";
    IconTypes["GRUPPE_DYN"] = "gruppe";
    IconTypes["HANDLEKURV_DYN"] = "handlekurv";
    IconTypes["HANDTRYKK_DYN"] = "handtrykk";
    IconTypes["HANDTVERKER_BIL_DYN"] = "handtverker-bil";
    IconTypes["HANDVERKER_DYN"] = "handverker";
    IconTypes["HELSE_DYN"] = "helse";
    IconTypes["HENGELAS_APEN_DYN"] = "hengelas-apen";
    IconTypes["HEST_DYN"] = "hest";
    IconTypes["HONE_DYN"] = "hone";
    IconTypes["HUND_DYN"] = "hund";
    IconTypes["HUS_DYN"] = "hus";
    IconTypes["HYTTE_DYN"] = "hytte";
    IconTypes["INBOX_DYN"] = "inbox";
    IconTypes["INFO_DYN"] = "info";
    IconTypes["INNBOFORSIKRING_DYN"] = "innboforsikring";
    IconTypes["INNFRI_KREDITTKORT_DYN"] = "innfri-kredittkort";
    IconTypes["INNSTILLINGER_DYN"] = "innstillinger";
    IconTypes["INNTEKT_DYN"] = "inntekt";
    IconTypes["INSTAGRAM_24"] = "instagram-24";
    IconTypes["INSTAGRAM_36"] = "instagram-36";
    IconTypes["INSTAGRAM_DYN"] = "instagram";
    IconTypes["JORDEN_DYN"] = "jorden";
    IconTypes["KAKEDIAGRAM_DYN"] = "kakediagram";
    IconTypes["KALENDER_DYN"] = "kalender";
    IconTypes["KALKULATOR_DYN"] = "kalkulator";
    IconTypes["KAMERA_DYN"] = "kamera";
    IconTypes["KART_DYN"] = "kart";
    IconTypes["KJORETOY_DYN"] = "kjoretoy";
    IconTypes["KLOKKE_DYN"] = "klokke";
    IconTypes["KONTOER_DYN"] = "kontoer";
    IconTypes["KONTOR_DYN"] = "kontor";
    IconTypes["KREDITTGRENSE_DYN"] = "kredittgrense";
    IconTypes["KRYSS_DYN"] = "kryss";
    IconTypes["KU_DYN"] = "ku";
    IconTypes["LAN_DYN"] = "lan";
    IconTypes["LASTEBIL_DYN"] = "lastebil";
    IconTypes["LEGE_DYN"] = "lege";
    IconTypes["LINKEDIN_24"] = "linkedin-24";
    IconTypes["LINKEDIN_36"] = "linkedin-36";
    IconTypes["LINKEDIN_DYN"] = "linkedin";
    IconTypes["LOMMEBOK_DYN"] = "lommebok";
    IconTypes["LYSPAERE_DYN"] = "lyspaere";
    IconTypes["MAIL_DYN"] = "mail";
    IconTypes["MASTERCARD_DYN"] = "mastercard";
    IconTypes["MEDALJE_DYN"] = "medalje";
    IconTypes["MER_DYN"] = "mer";
    IconTypes["MINUS_DYN"] = "minus";
    IconTypes["MOBIL_DYN"] = "mobil";
    IconTypes["MOBILBANK_DYN"] = "mobilbank";
    IconTypes["MOPED_DYN"] = "moped";
    IconTypes["MOTORSYKKEL_DYN"] = "motorsykkel";
    IconTypes["NEDLASTING_DYN"] = "nedlasting";
    IconTypes["NETTBANK_DYN"] = "nettbank";
    IconTypes["NOKKEL_DYN"] = "nokkel";
    IconTypes["NYHETER_DYN"] = "nyheter";
    IconTypes["OVERFOERE_DYN"] = "overfoere";
    IconTypes["OYE_DYN"] = "oye";
    IconTypes["PARAPLY_DYN"] = "paraply";
    IconTypes["PENGESEKK_DYN"] = "pengesekk";
    IconTypes["PENN_DYN"] = "penn";
    IconTypes["PERSONER_DYN"] = "personer";
    IconTypes["PIN_KODE_DYN"] = "pin-kode";
    IconTypes["PLANTE_DYN"] = "plante";
    IconTypes["PLASTER_DYN"] = "plaster";
    IconTypes["PLUSS_DYN"] = "pluss";
    IconTypes["PRINT_DYN"] = "print";
    IconTypes["PROFIL_DYN"] = "profil";
    IconTypes["RADGIVER_DYN"] = "radgiver";
    IconTypes["RADGIVING_DYN"] = "radgiving";
    IconTypes["REFINANSIERING_DYN"] = "refinansiering";
    IconTypes["REGIONSPERRE_DYN"] = "regionsperre";
    IconTypes["RENTER_DYN"] = "renter";
    IconTypes["RESIRKULER_DYN"] = "resirkuler";
    IconTypes["SIGNATUR_DYN"] = "signatur";
    IconTypes["SIKKERHET_DYN"] = "sikkerhet";
    IconTypes["SKADE_DYN"] = "skade";
    IconTypes["SLETT_DYN"] = "slett";
    IconTypes["SNAPCASH_DYN"] = "snapcash";
    IconTypes["SNAPCHAT_24"] = "snapchat-24";
    IconTypes["SNAPCHAT_36"] = "snapchat-36";
    IconTypes["SNAPCHAT_DYN"] = "snapchat";
    IconTypes["SNOSCOOTER_DYN"] = "snoscooter";
    IconTypes["SOEK_DYN"] = "soek";
    IconTypes["SPAREGRIS_DYN"] = "sparegris";
    IconTypes["SPARING_DYN"] = "sparing";
    IconTypes["SPERR_KORT_DYN"] = "sperr-kort";
    IconTypes["STJERNE_DYN"] = "stjerne";
    IconTypes["STOPP_DYN"] = "stopp";
    IconTypes["TANNHJUL_DYN"] = "tannhjul";
    IconTypes["TAXI_DYN"] = "taxi";
    IconTypes["TELEFON_DYN"] = "telefon";
    IconTypes["TILHENGER_DYN"] = "tilhenger";
    IconTypes["TIMEGLASS_DYN"] = "timeglass";
    IconTypes["TRAKTOR_DYN"] = "traktor";
    IconTypes["TREKANT_KRYSS_DYN"] = "trekant-kryss";
    IconTypes["UFOR_DYN"] = "ufor";
    IconTypes["ULYKKE_DYN"] = "ulykke";
    IconTypes["UNG_DYN"] = "ung";
    IconTypes["USP_CHECKMARK_DYN"] = "usp-checkmark";
    IconTypes["UTROPSTEGN_DYN"] = "utropstegn";
    IconTypes["VARETRANSPORT_DYN"] = "varetransport";
    IconTypes["VARSLER_DYN"] = "varsler";
    IconTypes["VEKST_DYN"] = "vekst";
    IconTypes["VEKT_DYN"] = "vekt";
    IconTypes["VERDI_DYN"] = "verdi";
    IconTypes["YOUTUBE_24"] = "youtube-24";
    IconTypes["YOUTUBE_36"] = "youtube-36";
    IconTypes["YOUTUBE_DYN"] = "youtube";
    IconTypes["X_24"] = "x-24";
    IconTypes["X_36"] = "x-36";
    IconTypes["X_DYN"] = "x";
})(IconTypes || (IconTypes = {}));
export default IconTypes;
//# sourceMappingURL=data:application/json;base64,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